import { Box } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import i18n from 'modules/core/lib/i18n'

import { TaxRateEntitySelector } from '../../../TaxRateEntitySelector'
import { SectionTitle } from './_SectionTitle'
import { SaleInvoiceFormFields } from './types'

interface RetentionSectionProps {
  form: FormikProps<SaleInvoiceFormFields>
  readOnly?: boolean
  disableRetentionTaxRate?: boolean
}

export const RetentionSection: React.FC<RetentionSectionProps> = ({
  form,
  readOnly = false,
  disableRetentionTaxRate = false,
}) => {
  return (
    <Box paddingTop="s16" paddingBottom="s16" gap="s16">
      <SectionTitle title={i18n.t('finance.sale_invoices.form.retention_title')} />
      <Box
        width="full"
        flexDirection="row"
        gap="s16"
        style={{
          width: '50%',
          paddingRight: '8px',
        }}
      >
        <TaxRateEntitySelector
          label={i18n.t('finance.sale_invoices.form.line_items.tax_rate')}
          value={form.values.retentionTaxRate ?? null}
          readOnly={readOnly || disableRetentionTaxRate}
          onChange={(taxRate) => {
            form.setValues({
              ...form.values,
              retentionTaxRate: taxRate,
            })
          }}
          error={form.errors.retentionTaxRate}
          hideSearchIcon
          country={form.values.legalEntity?.country}
          type={'personal_income'}
          source={'system'}
        />
      </Box>
    </Box>
  )
}
